import React from "react";
import PropTypes from "prop-types";
import { Outlet } from "react-router-dom";
import SFHeading from "../../heading";
import { SFNavTabs, SFNavTab } from "../../tabBar";
import SFContainer, { SFPageContainer } from "../../container";
import { SFStack } from "../../grid";
import getStyled from "../../../hooks/getStyled";
import CreateReactPortal from "../../../hooks/createReactPortal";
import { hasPermission } from "../../authorized";
const { styled } = getStyled();

const StyledContainer = styled(SFContainer)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  borderBottom: `1px solid ${theme.palette.grey200.main}`,
  display: "flex",
  justifyContent: "center",
  "& .tabs-heading": {
    paddingLeft: theme.spacing(5),
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  "& .tabs": {
    width: "100%",
    maxWidth: theme.screenMaxWidth,
    padding: theme.spacing(0, 3),
  },
}));

const StyledStack = styled(SFStack)(({ theme }) => ({
  height: "100%",
}));

const TabbedSubLayout = ({ title, tabs, contentColorVariant }) => {
  return (
    <SFPageContainer disableGutters bgColorVariant={contentColorVariant}>
      <StyledStack spacing={0}>
        {CreateReactPortal(
          <StyledContainer disableGutters>
            {title && (
              <div className="tabs-heading">
                <SFHeading gutterBottom variant="h1">
                  {title}
                </SFHeading>
              </div>
            )}
            <div className="tabs">
              <SFNavTabs>
                {tabs
                  .filter((x) => hasPermission(x.permissions))
                  .map((tab, index) => (
                    <SFNavTab
                      key={index}
                      path={tab.path}
                      label={tab.label}
                    ></SFNavTab>
                  ))}
              </SFNavTabs>
            </div>
          </StyledContainer>,
          document.getElementById("tabbedLayoutRoot")
        )}
        <SFPageContainer bgColorVariant={contentColorVariant}>
          <Outlet></Outlet>
        </SFPageContainer>
      </StyledStack>
    </SFPageContainer>
  );
};

TabbedSubLayout.defaultProps = {
  contentColorVariant: SFPageContainer.defaultProps.bgColorVariant,
};

TabbedSubLayout.propTypes = {
  /*The header shown above tabs*/
  title: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  /*Tab content background color*/
  contentColorVariant: SFPageContainer.propTypes.bgColorVariant,
  /*These are an array of TabRoute components that should contain*/
  tabs: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string,
      label: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
      permissions: PropTypes.arrayOf(PropTypes.string),
    })
  ),
};

export default TabbedSubLayout;
